__turbopack_context__.v({
  "circleContainer": "SpeedTest-module__TPPwpa__circleContainer",
  "circleContainerBackground": "SpeedTest-module__TPPwpa__circleContainerBackground",
  "circleContainerProgress": "SpeedTest-module__TPPwpa__circleContainerProgress",
  "container": "SpeedTest-module__TPPwpa__container",
  "indicators": "SpeedTest-module__TPPwpa__indicators",
  "info": "SpeedTest-module__TPPwpa__info",
  "main": "SpeedTest-module__TPPwpa__main",
  "red": "SpeedTest-module__TPPwpa__red",
  "speedTestOutcome": "SpeedTest-module__TPPwpa__speedTestOutcome",
  "stop1": "SpeedTest-module__TPPwpa__stop1",
  "stop2": "SpeedTest-module__TPPwpa__stop2",
  "stop3": "SpeedTest-module__TPPwpa__stop3",
  "testControls": "SpeedTest-module__TPPwpa__testControls",
  "testInfo": "SpeedTest-module__TPPwpa__testInfo",
  "testParams": "SpeedTest-module__TPPwpa__testParams",
  "title": "SpeedTest-module__TPPwpa__title",
  "yellow": "SpeedTest-module__TPPwpa__yellow",
});
